import {
  GET_RECORDS_FAIL,
  GET_RECORDS_REQUEST,
  GET_RECORDS_SUCCESS,
  ADD_RECORD_FAIL,
  ADD_RECORD_REQUEST,
  ADD_RECORD_SUCCESS,
  EDIT_RECORD_FAIL,
  EDIT_RECORD_REQUEST,
  EDIT_RECORD_SUCCESS,
  DELETE_RECORD_FAIL,
  DELETE_RECORD_REQUEST,
  DELETE_RECORD_SUCCESS
} from "./actions";
import { IMasterRecord } from "app/api/types";

interface IState {
  isLoading: boolean;
  masterRecordList: IMasterRecord[];
}
const initialState: IState = {
  masterRecordList: [],
  isLoading: false
};

const mastersReducer = (
  state = initialState,
  action: { type: any; payload: any }
) => {
  switch (action.type) {
    case GET_RECORDS_REQUEST:
    case EDIT_RECORD_REQUEST:
    case ADD_RECORD_REQUEST:
      return {
        ...state,
        isLoading: true
      };

    case DELETE_RECORD_REQUEST:
      return {
        ...state
      };

    case ADD_RECORD_FAIL:
    case GET_RECORDS_FAIL:
    case EDIT_RECORD_FAIL:
      return {
        ...state,
        isLoading: false
      };

    case DELETE_RECORD_FAIL:
      return {
        ...state
      };

    case GET_RECORDS_SUCCESS:
      return {
        ...state,
        masterRecordList: action.payload,
        isLoading: false
      };

    case ADD_RECORD_SUCCESS:
    case EDIT_RECORD_SUCCESS:
      return {
        ...state,
        isLoading: false
      };

    case DELETE_RECORD_SUCCESS:
      return {
        ...state,
        isLoading: true
      };
    default:
      return state;
  }
};

export default mastersReducer;
